import { Button, Form, message, Radio, Select, Row, Col } from 'antd';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';
import * as React from 'react';
import { IDoctorInfo, ISelectOption } from 'src/entity/DoctorEntity';
import DoctorService from 'src/services/DoctorService';
import I18N from 'src/services/I18NService';
import { RadioChangeEvent } from 'antd/lib/radio';

interface IPrescriptionRightFormProps extends FormComponentProps {
  doctorInfo: IDoctorInfo;
  /** 上级机构诊所选项列表 */
  superiorHospitalOptions: ISelectOption[];
  /** 表单提交成功后关闭模态窗函数 */
  closeModal(): void;
  /** 选择框搜索函数 */
  filterOption(input: string, option: any): boolean;
  /** 检查是否有下级医生关联处方权 */
  checkPrescriptionRight(e: RadioChangeEvent): boolean;
}

/**
 * 创建处方权编辑Form组件
 */
class CreatePrescriptionRightForm extends React.Component<IPrescriptionRightFormProps> {
  /** 表单是否可提交 */
  canSubmit: boolean = true;
  constructor(props: IPrescriptionRightFormProps) {
    super(props);
  }
  /**
   * 修改处方权相关内容
   */
  modifyPrescriptionRight = (e: React.SyntheticEvent) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        if (!this.canSubmit) {
          return;
        }
        try {
          const { doctorInfo } = this.props;
          if (!doctorInfo) {
            return;
          }
          // 处理处方权相关字段
          const isDoctorUser = doctorInfo.certification_level > 0;
          if (isDoctorUser) {
            doctorInfo.prescription_right = doctorInfo.certification_level !== 4 ? values.prescription_right : false;
            doctorInfo.superior_institution = values.superior_hospital;
            doctorInfo.cooperative_diagnosis_opened = values.cooperative_diagnosis_opened;
          } else {
            // [学习用户&&业务员] 处方权默认设置false
            doctorInfo.prescription_right = false;
            doctorInfo.superior_institution = null;
          }
          this.canSubmit = false;
          // 更新代理商医生信息
          await DoctorService.changeInstitutionDoctorInfo(doctorInfo);
          this.props.closeModal();
        } catch (error) {
          console.error(error);
          if (!!error.response) {
            message.error(JSON.stringify(error.response.data));
          } else {
            message.error(I18N.get('err_submit_failure'));
          }
        }
        this.canSubmit = true;
      }
    });
  };

  render() {
    const { form, doctorInfo, superiorHospitalOptions, filterOption } = this.props;
    const { getFieldDecorator, getFieldValue } = form;
    const formItemInlineLayoutRight: FormItemProps = {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
    };

    return (
      <Form onSubmit={this.modifyPrescriptionRight}>
        {doctorInfo.certification_level !== 4 && (
          <Row gutter={24} style={{ margin: 0 }}>
            <Form.Item label={I18N.get('doc_prescription_right')} {...formItemInlineLayoutRight}>
              {getFieldDecorator(`prescription_right`, {
                getValueFromEvent: this.props.checkPrescriptionRight,
                initialValue: !!doctorInfo ? (typeof doctorInfo.prescription_right === 'boolean' ? doctorInfo.prescription_right : false) : false,
                rules: [
                  {
                    required: true,
                    message: `${I18N.get('common_choose')}${I18N.get('doc_prescription_right')}`,
                  },
                ],
              })(
                <Radio.Group buttonStyle="solid">
                  <Radio.Button value={true}>{I18N.get('common_have')}</Radio.Button>
                  <Radio.Button value={false}>{I18N.get('common_none')}</Radio.Button>
                </Radio.Group>
              )}
            </Form.Item>
          </Row>
        )}
        <Row gutter={24} style={{ margin: 0 }}>
          <Form.Item label={I18N.get('doc_is_could_consultation')} {...formItemInlineLayoutRight}>
            {getFieldDecorator(`cooperative_diagnosis_opened`, {
              // getValueFromEvent: this.props.checkPrescriptionRight,
              initialValue: !!doctorInfo
                ? typeof doctorInfo.cooperative_diagnosis_opened === 'boolean'
                  ? doctorInfo.cooperative_diagnosis_opened
                  : false
                : false,
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_choose')}${I18N.get('doc_is_could_consultation')}`,
                },
              ],
            })(
              <Radio.Group buttonStyle="solid">
                <Radio.Button value={true}>{I18N.get('common_yes')}</Radio.Button>
                <Radio.Button value={false}>{I18N.get('common_no')}</Radio.Button>
              </Radio.Group>
            )}
          </Form.Item>
        </Row>
        <Row gutter={24} style={{ margin: 0 }}>
          {/* 当关联上级类型为1时显示上级机构选择框 */}
          <Form.Item label={I18N.get('doc_superior_type')} {...formItemInlineLayoutRight}>
            {getFieldDecorator(`superior_hospital`, {
              initialValue: !!doctorInfo ? doctorInfo.superior_institution : null,
              rules: [
                {
                  required: getFieldValue('cooperative_diagnosis_opened'),
                  message: `${I18N.get('common_choose')}${I18N.get('doc_superior_institution')}`,
                },
              ],
            })(
              <Select
                showSearch={true}
                filterOption={filterOption}
                placeholder={`${I18N.get('common_choose')}${I18N.get('doc_superior_institution')}`}
                allowClear={true}
              >
                {superiorHospitalOptions.map((r) => {
                  return (
                    <Select.Option key={String(r.value)} value={r.value}>
                      {r.label}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
          </Form.Item>
        </Row>
        <Row gutter={24} style={{ margin: 0 }}>
          <Form.Item style={{ textAlign: 'center', margin: 0 }}>
            <Button type="primary" loading={!this.canSubmit} htmlType="submit">
              {I18N.get('common_ok')}
            </Button>
          </Form.Item>
        </Row>
      </Form>
    );
  }
}
const PrescriptionRightForm = Form.create<IPrescriptionRightFormProps>()(CreatePrescriptionRightForm);
export default PrescriptionRightForm;



// WEBPACK FOOTER //
// ./src/components/views/Doctor/PrescriptionRightForm.tsx